import React, { useState } from 'react';
import { Link } from 'react-router-dom';
export function MobileNav() {
  const [isOpen, setIsOpen] = useState(false);
  return <>
      {/* Desktop Navigation */}
      <nav className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A]/95 backdrop-blur-sm border-b border-[#2B2B2B]" data-id="element-183">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between" data-id="element-184">
          <Link to="/" className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity flex-shrink-0" onClick={() => setIsOpen(false)} data-id="element-185">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jXd6KyuddrgAfqwwkkpUrR/Lazy_Monk_Labs_Logo.png" alt="Lazy Monk Labs Logo" className="h-6 sm:h-7 md:h-8 w-auto" width="32" height="32" data-id="element-186" />
            <span className="hidden sm:inline text-sm md:text-base font-mono tracking-tight text-gray-400" data-id="element-187">
              Lazy Monk Labs
            </span>
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6 lg:gap-8" data-id="element-188">
            <Link to="/decoder" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono whitespace-nowrap" data-id="element-189">
              Decoder
            </Link>
            <Link to="/careers" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono whitespace-nowrap" data-id="element-190">
              Careers
            </Link>
            <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="text-sm text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono whitespace-nowrap" data-id="element-191">
              Contact
            </a>
          </div>

          {/* Mobile Hamburger */}
          <button onClick={() => setIsOpen(!isOpen)} className="md:hidden p-2 text-[#F5F5F5] hover:text-gray-400 transition-colors flex-shrink-0" aria-label="Toggle menu" aria-expanded={isOpen} data-id="element-192">
            {isOpen ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-193">
                <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-194" />
              </svg> : <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-195">
                <path d="M3 12H21M3 6H21M3 18H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" data-id="element-196" />
              </svg>}
          </button>
        </div>

        {/* Mobile Menu */}
        {isOpen && <div className="md:hidden border-t border-[#2B2B2B] bg-[#0A0A0A]" data-id="element-197">
            <div className="px-4 py-6 space-y-4" data-id="element-198">
              <Link to="/decoder" className="block py-3 text-base text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" onClick={() => setIsOpen(false)} data-id="element-199">
                Decoder
              </Link>
              <Link to="/careers" className="block py-3 text-base text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" onClick={() => setIsOpen(false)} data-id="element-200">
                Careers
              </Link>
              <a href="https://wa.me/919633096997" target="_blank" rel="noopener noreferrer" className="block py-3 text-base text-gray-500 hover:text-[#F5F5F5] transition-colors font-mono" onClick={() => setIsOpen(false)} data-id="element-201">
                Contact
              </a>
            </div>
          </div>}
      </nav>
    </>;
}